import useHost from "./host";

export default function useGATag() {
    const host = useHost();
    if (host === "scored.co") return "G-72P20HB5GH";
    if (host === "communities.win") return "G-RCXXN3KHCJ";
    if (host === "patriots.win") return "G-Z9WBZVFLPZ";
    return "1";
}
